"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=collection.capture.js.map